import GridTexsEntrantController from './grid-dd-entrant.controller';
import Template from './grid-dd-entrant.html';

export default {
	bindings: {
		loading: '=',
		table: '=',
		pipe: '@'
	},
	controller: GridTexsEntrantController,
	template: Template
};
